<template>
<div class="class-progress">
    <transition appear @before-appear="beforeAppear" @appear="onAppear">
        <div
            class="progress-bar"
            :data-percent="progress"
            :style="{ width: progress + '%', backgroundColor: color.primary }"
        />
    </transition>
</div>
</template>

<script>
export default {
    name: 'ClassContentProgressBar',
    props: {
        content: {
            type: Object,
            default: () => ({
                plan: null,
                course: null,
                module: null,
                lesson: null,
                exercise: null,
            }),
        },
        type: String,
        progress: Number,
        noShadow: Boolean,
        noCard: Boolean,
    },
    data() {
        return {
            width: 0,
            localProgress: null,
        };
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
    },
    methods: {
        // Animação da barra de progresso
        beforeAppear(el) {
            el.style.width = 0;
        },
        // Animação da barra de progresso
        onAppear(el, done) {
            const interval = setInterval(() => {
                if (this.width > (this.progress + 1) || this.width === 101) {
                    clearInterval(interval);
                    return done();
                }

                el.style.width = `${this.width}%`;
                this.width++;
            }, 10);
        },
    },
};
</script>

<style lang="sass" scoped>
.class-progress
    width: 100%
    position: absolute
    bottom: 0
    left: 0
    height: 4px
    background-color: white
    border: none
    .progress-bar
        filter: brightness(1.5)
        width: 40%
        position: absolute
        bottom: 0
        left: 0
        height: 4px
        background-color: red
</style>
